// extracted by mini-css-extract-plugin
export var content = "_or-1";
export var fullScreen = "_or-0";